module.exports = __webpack_public_path__ + "img/sidebar-icon-menu-dark.79f24bcd.svg";